import genererRelance from '@/services/presse/regleFacturation/genererRelance';
import { DIRECT } from '@/configuration/presse/regleFacturation/regleFacturationConf';

export default function genererRegleFacturation() {
  return {
    code: null,
    libelle: null,
    type: DIRECT,
    facture: {
      piedPage: null,
      zoneInfoPaiement: null,
      zoneInfoDivers: null,
      logoTailleX: null,
      logoTailleY: null,
    },
    relance1: genererRelance(),
    relance2: genererRelance(),
    relance3: genererRelance(),
    societeId: null,
  };
}
